export default "__VITE_PUBLIC_ASSET__6d6d5793__"